// extracted by mini-css-extract-plugin
module.exports = {"sider_box":"sider_box-3IsutpHr","sider":"sider-MbzgrDx7","ipad_sider":"ipad_sider-1PQxqNAx"};